import { FC, ReactNode, useMemo } from 'react';
import { CheckIcon } from '../../assets/svg/check';
import { Dropdown } from '../../components/dropdown/dropdown';
import { pageKey } from '../../helpers/path';
import { useQueryParams } from '../../hooks/use-query-params';
import { SortType } from '../../types/props';
import { sortKey } from '../table/helpers';

type SortOption = {
  label: ReactNode;
  value: string;
  dir: SortType;
};

interface Props {
  label: ReactNode;
  options: SortOption[];
  leftIcon?: ReactNode;
  className?: string;
}

export const DropdownSorter: FC<Props> = (props) => {
  const { label, options, leftIcon, className } = props;
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();

  const sortParam = useMemo(() => {
    try {
      return JSON.parse(params[sortKey] || '{}') as Record<string, SortType>;
    } catch {
      return {};
    }
  }, [params]);

  const dropdownOptions = options.map((opt) => ({
    key: opt.value,
    label: opt.label,
    onClick: () => {
      const newParams = JSON.stringify({ [opt.value]: opt.dir });
      const isSame = newParams === params[sortKey];

      addQueryParams({
        [sortKey]: isSame ? undefined : newParams,
        [pageKey]: '1',
      });
    },
    isActive: sortParam[opt.value] === opt.dir,
    content: sortParam[opt.value] === opt.dir ? <CheckIcon /> : null,
  }));

  return (
    <Dropdown
      label={label}
      leftIcon={leftIcon}
      className={className}
      options={dropdownOptions}
      highlightTriggerOnly
    />
  );
};
